@if (icon) {
  <rask-icon icon="{{icon}}" text="{{message}}"></rask-icon>
}
